.root {
  display: flex;
  justify-content: space-between;
  gap: var(--spacingLg);
  padding: var(--spacingMd) var(--spacingXl);
  border-radius: var(--radiusSm);
  background: var(--paletteNeutral1);
  min-width: 0;
  width: 100%;
}

.billable {
  flex: 1;
}

.affectsAvailability {
  flex: 2;
}
